import { render, staticRenderFns } from "./GovernanceRelevantBizInnoInfoList.vue?vue&type=template&id=eade8c84&scoped=true&"
import script from "./GovernanceRelevantBizInnoInfoList.vue?vue&type=script&lang=js&"
export * from "./GovernanceRelevantBizInnoInfoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eade8c84",
  null
  
)

export default component.exports